import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import { Helmet } from 'react-helmet'

import './blogs.css'
import { contentfulImageUrl, contentfulImageSrcSet } from '../../lib/contentful-image'
import ArticlePreview from './components/artical-preview.js'
import SEO, { PERSON_ID, SITE_URL } from '../../components/seo'

class Blogs extends React.Component { 
  render() {
      const posts = get(this, 'props.data.allContentfulBlogPost.edges')
      const firstImage = posts[0].node.heroImage.fluid.src

      return (
          <div className="wrapper">
              <SEO
                title="张喆的博客｜doubleZ"
                description="张喆（Zhe Zhang / Zhang Zhe / doubleZ）的个人博客，记录北京大学、同济大学、计算机视觉、AIGC、科研、技术与生活。"
                pathname="/blogs/"
                structuredData={{
                  '@type': 'CollectionPage',
                  '@id': `${SITE_URL}/blogs/#collection-page`,
                  url: `${SITE_URL}/blogs/`,
                  name: '张喆的博客｜doubleZ',
                  author: { '@type': 'Person', '@id': PERSON_ID, name: '张喆', alternateName: 'Zhe Zhang', url: `${SITE_URL}/` },
                  inLanguage: 'zh-CN',
                  mainEntity: {
                    '@type': 'ItemList',
                    itemListElement: posts.map(({ node }, index) => ({
                      '@type': 'ListItem',
                      position: index + 1,
                      url: `${SITE_URL}/blogs/${node.slug}/`,
                      name: node.title,
                    })),
                  },
                }}
              />
              <Helmet>
                  <link rel='preconnect' href='https://images.ctfassets.net' crossOrigin='anonymous' />
                  <link rel='preload' as='image' href={contentfulImageUrl(firstImage, 960)} imagesrcset={contentfulImageSrcSet(firstImage, [480, 720, 960, 1280])} imagesizes='80vw' />
              </Helmet>
              <ul id="article-list" className="article-list">
                  {posts.map(({ node }, index) => {
                      return (
                      <li key={node.slug}>
                          <ArticlePreview article={node} priority={index === 0} />
                      </li>
                      )
                  })}
              </ul>
        </div>
      )
  }
}

export default Blogs

export const pageQuery = graphql`
  query BlogsQuery {
    allContentfulBlogPost(sort: { fields: [publishDate], order: DESC }) {
      edges {
        node {
          title
          slug
          publishDate(formatString: "YYYY-MM-DD")
          tags
          heroImage {
            fluid(maxWidth: 1000) {
              src
            }
          }
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
